@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.screens_cus_mobile.wa

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.example.project.dashboard.DashboardTheme
import org.example.project.engineslot.SLOT_BEREICH_WA
import org.example.project.screens_cus_mobile.loadMobileErlaubteStandorte
import org.example.project.screens_cus_mobile.MobileYardPalettenscheinExportHost
import org.example.project.screens_cus_mobile.MOBILE_YARD_STORED_PDF_ENABLED
import org.example.project.screens_cus_mobile.mobileClaimForCurrentUser
import org.example.project.screens_cus_mobile.mobileCurrentBearbeiterId
import org.example.project.engineslot.slotLadenTouren
import org.example.project.screens_cus_mobile.mobileIsOwnRunning
import org.example.project.screens_cus_mobile.mobileIsOwnBearbeitung
import org.example.project.screens_cus_mobile.mobileIsLkwFlowZustand
import org.example.project.screens_cus_mobile.mobileIsSelectableAngekommen
import org.example.project.screens_cus_mobile.mobileIsUnassignedRunning
import org.example.project.screens_cus_mobile.mobileStandortErlaubt
import org.example.project.service.GlobalManager
import org.example.project.service.YardApi
import org.example.project.service.YardEngineApi
import org.example.project.service.YardFlowApi
import org.example.project.service.YardLiveSync
import org.example.project.service.ZustandManager
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.example.project.utils.All
import org.example.project.yard.WA_SAMMEL_ID_EXTRA
import org.example.project.yard.WA_SAMMEL_PIN_EXTRA
import org.example.project.yard.yardPinBestaetigt
import org.example.project.yard.yardPinCode
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun CUSMobileWAFlowScreen() {
    val scope = rememberCoroutineScope()

    var liste by remember { mutableStateOf<List<All>>(emptyList()) }
    var kontrolleDefinitionen by remember { mutableStateOf<List<All>>(emptyList()) }
    var waStandorteByTour by remember { mutableStateOf<Map<String, List<All>>>(emptyMap()) }
    var waLkwAll by remember { mutableStateOf<List<All>>(emptyList()) }
    var wartenderAuftrag by remember { mutableStateOf<All?>(null) }
    var aktiverFlow by remember { mutableStateOf<All?>(null) }
    var pinPruefungAuftrag by remember { mutableStateOf<All?>(null) }
    var startenderAuftragId by remember { mutableStateOf<String?>(null) }
    var palettenscheinQueue by remember { mutableStateOf<List<All>>(emptyList()) }
    var palettenscheinWarteAuftrag by remember { mutableStateOf<All?>(null) }
    var palettenscheinErstellungAktiv by remember { mutableStateOf(false) }
    var palettenscheinGesamt by remember { mutableStateOf(0) }
    var palettenscheinWarteFertig by remember { mutableStateOf(false) }
    var palettenscheinWarteFehler by remember { mutableStateOf(false) }
    var palettenscheinWarteText by remember { mutableStateOf("Palettenschein wird erstellt") }
    var palettenscheinDokumentProgress by remember { mutableStateOf(0) }
    var palettenscheinAbschlussAuftraege by remember { mutableStateOf<List<All>>(emptyList()) }
    var palettenscheinDokumentAuftraege by remember { mutableStateOf<List<All>>(emptyList()) }
    var naechsterStandortAuftrag by remember { mutableStateOf<All?>(null) }
    val bearbeiterId = mobileCurrentBearbeiterId()
    val refreshVersion = YardLiveSync.version()

    fun resolveWaStandort(auftrag: All): All? {
        auftrag.waStandortId.takeIf { id -> id.isNotBlank() }?.let { id ->
            waStandorteByTour[auftrag.lieferscheinnummer].orEmpty()
                .firstOrNull { it.id == id }
                ?.let { return it }
        }

        val gruppenStandortQuelle = waLkwAll.mobileWaSammelGroup(auftrag)
            .firstNotNullOfOrNull { entry ->
                entry.waStandortId.takeIf { id -> id.isNotBlank() && entry.lieferscheinnummer == auftrag.lieferscheinnummer }?.let { id -> entry.lieferscheinnummer to id }
            }
        if (gruppenStandortQuelle != null) {
            waStandorteByTour[gruppenStandortQuelle.first].orEmpty()
                .firstOrNull { it.id == gruppenStandortQuelle.second }
                ?.let { return it }
        }

        val details = waStandorteByTour[auftrag.lieferscheinnummer].orEmpty()
            .filter { it.zustand != ZustandManager.ABGESCHLOSSEN && it.zustand != ZustandManager.STORNIERT }
        if (details.isEmpty()) return null

        details.firstOrNull { detail ->
            (auftrag.id.isNotBlank() && detail.id == auftrag.id) ||
                (auftrag.lfdNr > 0 && detail.lfdNr > 0 && detail.lfdNr == auftrag.lfdNr)
        }?.let { return it }

        auftrag.platzcode.takeIf { it.isNotBlank() }?.let { platzcode ->
            details.firstOrNull { it.platzcode == platzcode }?.let { return it }
        }
        auftrag.tor?.let { tor ->
            details.firstOrNull { it.tor == tor }?.let { return it }
        }
        auftrag.standort.takeIf { it.isNotBlank() }?.let { standort ->
            details.firstOrNull { it.standort == standort }?.let { return it }
        }
        auftrag.ort.takeIf { it.isNotBlank() }?.let { ort ->
            details.firstOrNull { it.ort == ort || it.standort == ort }?.let { return it }
        }

        return when (details.size) {
            1 -> details.first()
            else -> details.sortedWith(compareBy<All> { if (it.ablaufPrio > 0) it.ablaufPrio else Int.MAX_VALUE }.thenBy { it.id }).firstOrNull()
        }
    }

    fun mitWaStandortPaletten(auftrag: All): All {
        val standort = resolveWaStandort(auftrag) ?: return auftrag
        val offenePaletten = mobileWaOffenePalettenAnzeige(auftrag, standort)
        val standortPaletten = offenePaletten.toIntOrNull()
        if (standortPaletten == null) return auftrag.copy(
            platzcode = auftrag.platzcode.ifBlank { standort.platzcode },
            platz = auftrag.platz.ifBlank { standort.platz },
            standort = auftrag.standort.ifBlank { standort.standort },
            tor = auftrag.tor ?: standort.tor,
            torcode = auftrag.torcode.orEmpty().ifBlank { standort.torcode.orEmpty() },
            waStandortId = standort.id
        )
        return auftrag.copy(
            palettenanzahl = standortPaletten,
            palettenWerte = emptyMap(),
            platzcode = auftrag.platzcode.ifBlank { standort.platzcode },
            platz = auftrag.platz.ifBlank { standort.platz },
            standort = auftrag.standort.ifBlank { standort.standort },
            tor = auftrag.tor ?: standort.tor,
            torcode = auftrag.torcode.orEmpty().ifBlank { standort.torcode.orEmpty() },
            waStandortId = standort.id,
            yardabschlussOffenPaletten = offenePaletten.toIntOrNull() ?: 0
        )
    }

    fun mitMultiOffenSumme(auftrag: All): All {
        val group = waLkwAll.mobileWaSammelGroup(auftrag)
        if (group.size <= 1) return mitWaStandortPaletten(auftrag)
        val offenSumme = group
            .map(::mitWaStandortPaletten)
            .sumOf { it.yardabschlussOffenPaletten }
        return mitWaStandortPaletten(auftrag).copy(palettenanzahl = offenSumme)
    }

    fun mitWaAbschlussPaletten(auftrag: All): All {
        val mitStandort = mitWaStandortPaletten(auftrag)
        val lkwSoll = auftrag.palettenanzahl.takeIf { it > 0 }
        if (lkwSoll == null) return mitStandort
        return mitStandort.copy(
            palettenanzahl = lkwSoll,
            yardabschlussOffenPaletten = mitStandort.yardabschlussOffenPaletten.takeIf { it > 0 } ?: lkwSoll
        )
    }

    fun zeigeWaBearbeitung(lkw: All) {
        val lkwMitStandort = mitWaStandortPaletten(lkw)
        when {
            lkw.zustand == ZustandManager.TOR_ZUGEWIESEN -> {
                wartenderAuftrag = lkwMitStandort
                pinPruefungAuftrag = null
                aktiverFlow = null
            }
            lkw.zustand == ZustandManager.PIN_ABFRAGE && !yardPinBestaetigt(lkw) -> {
                pinPruefungAuftrag = lkwMitStandort
                wartenderAuftrag = null
                aktiverFlow = null
            }
            lkw.zustand == ZustandManager.IN_VERLADUNG -> {
                aktiverFlow = lkwMitStandort
                wartenderAuftrag = null
                pinPruefungAuftrag = null
            }
        }
    }

    suspend fun waBearbeitungWiederAufnehmen(lkw: All): All {
        val claimed = mobileClaimForCurrentUser(mitWaStandortPaletten(lkw))
        val standortDetail = resolveWaStandort(claimed)
        return when (lkw.zustand) {
            ZustandManager.TOR_ZUGEWIESEN -> YardFlowApi.maNimmtAuftragAn(
                auftrag = claimed,
                artCode = SLOT_BEREICH_WA,
                firmenId = claimed.firmenId,
                standortDetail = standortDetail
            )
            ZustandManager.PIN_ABFRAGE -> YardFlowApi.fahrerBestaetigtAngesetzt(
                auftrag = claimed,
                artCode = SLOT_BEREICH_WA,
                firmenId = claimed.firmenId
            )
            ZustandManager.IN_VERLADUNG -> YardFlowApi.maBestaetigtPin(
                auftrag = claimed,
                artCode = SLOT_BEREICH_WA,
                firmenId = claimed.firmenId
            )
            else -> claimed
        }
    }

    suspend fun ladeDaten() {
        val erlaubteStandorte = loadMobileErlaubteStandorte()
        val waAuftraege = YardApi.loadWaListe()
        waStandorteByTour = waAuftraege
            .map { it.lieferscheinnummer }
            .filter { it.isNotBlank() }
            .distinct()
            .associateWith { YardApi.loadWaStandorteByTour(it) }
        kontrolleDefinitionen = YardApi.loadKontrolleDefinitionen().filter { it.aktivWa }
        val alleLkw = YardApi.loadWaLkwListe()
            .filter { it.zustand != ZustandManager.ABGESCHLOSSEN && it.zustand != ZustandManager.STORNIERT }
            .filter { mobileStandortErlaubt(it, erlaubteStandorte) }
        waLkwAll = alleLkw
        liste = alleLkw
            .filter { mobileIsSelectableAngekommen(it, bearbeiterId) }
            .sortedWith(
                compareBy<All> { if (mobileIsOwnBearbeitung(it, bearbeiterId)) 0 else 1 }
                    .thenBy { if (it.ablaufPrio > 0) it.ablaufPrio else Int.MAX_VALUE }
                    .thenBy { it.prio.toIntOrNull() ?: Int.MAX_VALUE }
                    .thenBy { it.uhrzeitAnmeldung }
            )
            .mobileWaSammelReps()
        if (palettenscheinWarteAuftrag != null || palettenscheinErstellungAktiv || palettenscheinQueue.isNotEmpty()) return
        if (naechsterStandortAuftrag != null) return
        if (wartenderAuftrag != null || pinPruefungAuftrag != null || aktiverFlow != null) return
        alleLkw.firstOrNull { mobileIsOwnRunning(it, bearbeiterId) }?.let { eigener ->
            zeigeWaBearbeitung(eigener)
            return
        }
        alleLkw.firstOrNull { mobileIsUnassignedRunning(it) }?.let { unzugeordnet ->
            val wiederaufgenommen = waBearbeitungWiederAufnehmen(unzugeordnet)
            zeigeWaBearbeitung(wiederaufgenommen)
        }
    }

    suspend fun findeNaechstenWaStandortNachAbschluss(seed: All): All? {
        val erlaubteStandorte = loadMobileErlaubteStandorte()
        val alleLkw = YardApi.loadWaLkwListe(seed.firmenId)
            .filter { it.zustand != ZustandManager.ABGESCHLOSSEN && it.zustand != ZustandManager.STORNIERT }
            .filter { mobileStandortErlaubt(it, erlaubteStandorte) }
        waLkwAll = alleLkw
        val lieferscheine = alleLkw
            .map { it.lieferscheinnummer }
            .filter { it.isNotBlank() }
            .distinct()
        waStandorteByTour = lieferscheine.associateWith { YardApi.loadWaStandorteByTour(it) }
        val slotMultiKey = seed.mobileWaSlotMultiKey()
        val kandidaten = if (slotMultiKey.isNotBlank()) {
            alleLkw
                .filter { it.mobileWaSlotMultiKey() == slotMultiKey }
                .mobileWaSammelReps()
        } else {
            alleLkw.mobileWaSammelGroup(seed)
        }
        return kandidaten
            .map(::mitWaStandortPaletten)
            .sortedWith(
                compareBy<All> { if (it.ablaufPrio > 0) it.ablaufPrio else Int.MAX_VALUE }
                    .thenBy { it.lieferscheinnummer }
                    .thenBy { it.id.ifBlank { it.lfdNr.toString() } }
            )
            .firstOrNull()
    }

    LaunchedEffect(refreshVersion) {
        ladeDaten()
    }

    LaunchedEffect(wartenderAuftrag?.lieferscheinnummer, wartenderAuftrag?.id, wartenderAuftrag?.lfdNr) {
        val wartend = wartenderAuftrag ?: return@LaunchedEffect
        while (wartenderAuftrag != null) {
            val aktuell = YardApi.loadWaLkwListe(wartend.firmenId)
                .firstOrNull { it.sameWaLkw(wartend) }
            if (aktuell != null) {
                val aktuellMitStandort = mitWaStandortPaletten(aktuell)
                wartenderAuftrag = aktuellMitStandort
                if (aktuell.zustand == ZustandManager.PIN_ABFRAGE) {
                    pinPruefungAuftrag = aktuellMitStandort
                    wartenderAuftrag = null
                    return@LaunchedEffect
                }
                if (aktuell.zustand == ZustandManager.IN_VERLADUNG) {
                    aktiverFlow = aktuellMitStandort
                    wartenderAuftrag = null
                    return@LaunchedEffect
                }
                if (aktuell.zustand != ZustandManager.TOR_ZUGEWIESEN) {
                    wartenderAuftrag = null
                    ladeDaten()
                    return@LaunchedEffect
                }
            }
            delay(2000)
        }
    }

    suspend fun waBeladenStarten(auftrag: All): All {
        val auftragMitGruppenStandort = mitWaStandortPaletten(auftrag)
        val standortDetail = resolveWaStandort(auftragMitGruppenStandort)
        val aktualisierterAuftrag = YardFlowApi.maNimmtAuftragAn(
            auftrag = auftragMitGruppenStandort,
            artCode = SLOT_BEREICH_WA,
            firmenId = auftrag.firmenId,
            standortDetail = standortDetail
        )
        ladeDaten()
        return aktualisierterAuftrag
    }

    suspend fun pinBestaetigen(auftrag: All): All {
        val aktualisiert = YardFlowApi.maBestaetigtPin(auftrag, SLOT_BEREICH_WA, auftrag.firmenId)
        ladeDaten()
        return aktualisiert
    }

    suspend fun flowAbschliessen(auftrag: All, leergut: String, antworten: Map<String, String>, istPaletten: String) {
        val leergutWert = leergut.ifBlank { "0" }
        val pending = auftrag.copy(
            leerpalettenanzahl = leergutWert.toIntOrNull() ?: auftrag.leerpalettenanzahl,
            palettenanzahl = auftrag.palettenanzahl,
            palettenWerte = auftrag.palettenWerte + antworten.filterValues { it.isNotBlank() },
            mobilPendingLeergut = leergutWert,
            mobilIstPaletten = istPaletten.toIntOrNull() ?: 0,
            yardabschlussIstPaletten = istPaletten.toIntOrNull() ?: 0
        )
        palettenscheinQueue = palettenscheinQueue + pending
        palettenscheinWarteAuftrag = pending
        palettenscheinGesamt = 1
        palettenscheinErstellungAktiv = true
        palettenscheinWarteFertig = false
        palettenscheinWarteFehler = false
        palettenscheinWarteText = "Palettenschein wird erstellt"
        palettenscheinDokumentProgress = 0
        palettenscheinAbschlussAuftraege = emptyList()
        palettenscheinDokumentAuftraege = emptyList()
        if (!MOBILE_YARD_STORED_PDF_ENABLED) aktiverFlow = null
    }

    suspend fun flowSammelAbschliessen(auftrag: All, leergut: String, antworten: Map<String, String>, istPalettenByAuftrag: Map<String, String>) {
        val group = waLkwAll.mobileWaSammelGroup(auftrag).ifEmpty { listOf(auftrag) }.map(::mitWaAbschlussPaletten)
        val gespeichert = mutableListOf<All>()
        group.forEachIndexed { index, entry ->
            val rowLeergut = if (index == 0) leergut.ifBlank { "0" } else entry.leerpalettenanzahl.takeIf { it > 0 }?.toString() ?: "0"
            val rowIstPaletten = istPalettenByAuftrag[entry.mobileWaAbschlussKey()].orEmpty()
            gespeichert.add(entry.copy(
                leerpalettenanzahl = rowLeergut.toIntOrNull() ?: entry.leerpalettenanzahl,
                palettenanzahl = entry.palettenanzahl,
                palettenWerte = entry.palettenWerte + antworten.filterValues { it.isNotBlank() },
                mobilPendingLeergut = rowLeergut,
                mobilIstPaletten = rowIstPaletten.toIntOrNull() ?: 0,
                yardabschlussIstPaletten = rowIstPaletten.toIntOrNull() ?: 0
            ))
        }
        if (gespeichert.isNotEmpty()) {
            palettenscheinQueue = palettenscheinQueue + gespeichert
            palettenscheinWarteAuftrag = gespeichert.first()
            palettenscheinGesamt = gespeichert.size
            palettenscheinErstellungAktiv = true
            palettenscheinWarteFertig = false
            palettenscheinWarteFehler = false
            palettenscheinWarteText = "Palettenschein wird erstellt"
            palettenscheinDokumentProgress = 0
            palettenscheinAbschlussAuftraege = emptyList()
            palettenscheinDokumentAuftraege = emptyList()
            if (!MOBILE_YARD_STORED_PDF_ENABLED) aktiverFlow = null
        }
    }

    suspend fun palettenscheinWaAbschlussSpeichern(auftrag: All): All? {
        GlobalManager.markLocalScreenWrite("MobileWAAuswahlScreen", suppressMs = 60000L)
        val gespeichert = YardEngineApi.waLkwAbschluss(
            auftrag = auftrag,
            firmenId = auftrag.firmenId,
            leergut = auftrag.mobilPendingLeergut,
            istPaletten = auftrag.mobilIstPaletten.toString()
        )
        if (gespeichert != null) {
            YardLiveSync.markAuftragChanged(gespeichert)
        }
        return gespeichert
    }

    fun starteWaAuftrag(lkw: All) {
        if (startenderAuftragId != null) return
        startenderAuftragId = lkw.id.ifBlank { lkw.lfdNr.toString() }
        liste = liste.filterNot { it.sameWaLkw(lkw) }
        scope.launch {
            try {
                val claimed = mobileClaimForCurrentUser(lkw)
                val aktualisiert = waBeladenStarten(claimed)
                when {
                    aktualisiert.zustand == ZustandManager.PIN_ABFRAGE && !yardPinBestaetigt(aktualisiert) -> {
                        pinPruefungAuftrag = mitWaStandortPaletten(aktualisiert)
                    }
                    aktualisiert.zustand == ZustandManager.IN_VERLADUNG -> {
                        aktiverFlow = mitWaStandortPaletten(aktualisiert)
                    }
                    aktualisiert.zustand == ZustandManager.TOR_ZUGEWIESEN -> {
                        wartenderAuftrag = mitWaStandortPaletten(aktualisiert)
                    }
                    else -> {
                        ladeDaten()
                    }
                }
            } finally {
                startenderAuftragId = null
            }
        }
    }

    MobileYardPalettenscheinExportHost(
        art = "WA",
        auftrag = if (palettenscheinErstellungAktiv) palettenscheinQueue.firstOrNull() else null,
        onPhaseChange = { palettenscheinWarteText = it },
        onDocumentProgress = { palettenscheinDokumentProgress = it.coerceIn(0, 100) },
        onPalettenscheinUploaded = { current ->
            if (palettenscheinGesamt > 1) {
                palettenscheinDokumentAuftraege = palettenscheinDokumentAuftraege + current
                current
            } else {
                val gespeichert = palettenscheinWaAbschlussSpeichern(current)
                if (gespeichert != null) {
                    palettenscheinAbschlussAuftraege = palettenscheinAbschlussAuftraege + gespeichert
                }
                gespeichert
            }
        },
        onFinished = { success ->
            if (!success) {
                palettenscheinWarteFehler = true
            } else {
                scope.launch {
                    palettenscheinErstellungAktiv = false
                    val remaining = palettenscheinQueue.drop(1)
                    palettenscheinQueue = remaining
                    if (remaining.isEmpty()) {
                        if (palettenscheinGesamt > 1) {
                            palettenscheinWarteText = "Aufträge werden abgeschlossen"
                            val abgeschlossen = mutableListOf<All>()
                            palettenscheinDokumentAuftraege.forEach { dokumentAuftrag ->
                                val gespeichert = palettenscheinWaAbschlussSpeichern(dokumentAuftrag)
                                if (gespeichert != null) {
                                    abgeschlossen += gespeichert
                                } else {
                                    palettenscheinWarteFehler = true
                                }
                            }
                            palettenscheinAbschlussAuftraege = palettenscheinAbschlussAuftraege + abgeschlossen
                            if (palettenscheinWarteFehler) return@launch
                        }
                        palettenscheinDokumentProgress = 100
                        palettenscheinWarteFertig = true
                        palettenscheinWarteText = "Dokumente wurden erzeugt."
                        ladeDaten()
                        if (!MOBILE_YARD_STORED_PDF_ENABLED) {
                            val abschlussSeed = palettenscheinWarteAuftrag
                            palettenscheinGesamt = 0
                            palettenscheinWarteFertig = false
                            palettenscheinWarteFehler = false
                            palettenscheinWarteText = "Palettenschein wird erstellt"
                            palettenscheinDokumentProgress = 0
                            palettenscheinAbschlussAuftraege = emptyList()
                            palettenscheinDokumentAuftraege = emptyList()
                            val naechster = abschlussSeed?.let { findeNaechstenWaStandortNachAbschluss(it) }
                            palettenscheinWarteAuftrag = null
                            if (naechster != null) {
                                naechsterStandortAuftrag = naechster
                                wartenderAuftrag = null
                                pinPruefungAuftrag = null
                            }
                        }
                    } else {
                        palettenscheinDokumentProgress = 0
                        palettenscheinErstellungAktiv = true
                        palettenscheinWarteText = "Palettenschein wird erstellt"
                    }
                }
            }
        }
    )

    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(16.px)
            padding(12.px)
            height(100.percent)
            minHeight(0.px)
            boxSizing("border-box")
        }
    }) {
        if (MOBILE_YARD_STORED_PDF_ENABLED && palettenscheinWarteAuftrag != null) {
            MobileWaArbeitsbereich(auftrag = mitMultiOffenSumme(palettenscheinWarteAuftrag!!)) {
                MobileWaPalettenscheinWarteScreen(
                    fertig = palettenscheinWarteFertig,
                    fehler = palettenscheinWarteFehler,
                    gesamt = palettenscheinGesamt,
                    verbleibend = palettenscheinQueue.size,
                    dokumentProgress = palettenscheinDokumentProgress,
                    statusText = palettenscheinWarteText,
                    mehrteiligerAbschluss = palettenscheinGesamt > 1,
                    onOk = {
                        if (!palettenscheinWarteFertig) return@MobileWaPalettenscheinWarteScreen
                        scope.launch {
                            val abschlussSeed = palettenscheinWarteAuftrag
                            palettenscheinErstellungAktiv = false
                            palettenscheinGesamt = 0
                            palettenscheinWarteFertig = false
                            palettenscheinWarteFehler = false
                            palettenscheinWarteText = "Palettenschein wird erstellt"
                            palettenscheinDokumentProgress = 0
                            palettenscheinAbschlussAuftraege = emptyList()
                            palettenscheinDokumentAuftraege = emptyList()
                            aktiverFlow = null
                            val naechster = abschlussSeed
                                ?.let { findeNaechstenWaStandortNachAbschluss(it) }
                            palettenscheinWarteAuftrag = null
                            if (naechster != null) {
                                naechsterStandortAuftrag = naechster
                                wartenderAuftrag = null
                                pinPruefungAuftrag = null
                                aktiverFlow = null
                            } else {
                                ladeDaten()
                            }
                        }
                    }
                )
            }
        } else if (naechsterStandortAuftrag != null) {
            MobileWaArbeitsbereich(auftrag = mitMultiOffenSumme(naechsterStandortAuftrag!!)) {
                MobileWaNaechsterStandortScreen(
                    auftrag = naechsterStandortAuftrag!!,
                    onWeiter = {
                        val naechster = naechsterStandortAuftrag ?: return@MobileWaNaechsterStandortScreen
                        naechsterStandortAuftrag = null
                        if (mobileIsLkwFlowZustand(naechster)) {
                            zeigeWaBearbeitung(naechster)
                        } else {
                            starteWaAuftrag(naechster)
                        }
                    }
                )
            }
        } else if (wartenderAuftrag != null) {
            MobileWaArbeitsbereich(auftrag = mitMultiOffenSumme(wartenderAuftrag!!)) {
                MobileWaWarteScreen()
            }
        } else if (pinPruefungAuftrag != null) {
            MobileWaArbeitsbereich(auftrag = mitMultiOffenSumme(pinPruefungAuftrag!!)) {
                MobileWaPinBestaetigungScreen(
                    auftrag = pinPruefungAuftrag!!,
                    onZurueck = { pinPruefungAuftrag = null },
                    onPinBestaetigt = { auftrag ->
                        scope.launch {
                            aktiverFlow = mitWaStandortPaletten(pinBestaetigen(auftrag))
                            pinPruefungAuftrag = null
                        }
                    }
                )
            }
        } else if (aktiverFlow != null) {
            val aktiverAuftragMitOffen = mitMultiOffenSumme(aktiverFlow!!)
            MobileWaArbeitsbereich(auftrag = aktiverAuftragMitOffen) {
                CUSMobileWAKontrolleScreen(
                    auftrag = aktiverAuftragMitOffen,
                    kontrolleDefinitionen = kontrolleDefinitionen,
                    showLeergutKontrolle = aktiverFlow!!.driverLeergutDabei,
                    abschlussAuftraege = waLkwAll.mobileWaSammelGroup(aktiverFlow!!).map(::mitWaAbschlussPaletten),
                    onZurueck = { aktiverFlow = null },
                    onAbschliessen = { leergut, antworten, istPaletten ->
                        flowAbschliessen(aktiverAuftragMitOffen, leergut, antworten, istPaletten)
                    },
                    onAbschliessenMehrfach = { leergut, antworten, istPalettenByAuftrag ->
                        flowSammelAbschliessen(aktiverFlow!!, leergut, antworten, istPalettenByAuftrag)
                    }
                )
            }
        } else {
            MobileWaHeader(
                offen = liste.size,
                inBearbeitung = liste.count { it.zustand >= ZustandManager.TOR_ZUGEWIESEN }
            )
            Div({ style { width(100.percent) } }) {
                LumaticaButton(
                    label = if (startenderAuftragId != null) "Wird gestartet..." else "Lkw Beladen",
                    onClick = {
                        if (startenderAuftragId != null) return@LumaticaButton
                        val erster = liste.firstOrNull() ?: return@LumaticaButton
                        starteWaAuftrag(erster)
                    },
                    variant = LumaticaButtonVariant.Action,
                    enabled = liste.isNotEmpty() && startenderAuftragId == null,
                    heightPx = 42
                )
            }

            liste.forEach { lkw ->
                val eigeneZuweisung = mobileIsOwnBearbeitung(lkw, bearbeiterId)
                Div({
                    style {
                        padding(16.px)
                        borderRadius(22.px)
                        background("linear-gradient(180deg, rgba(18,22,32,0.92) 0%, rgba(11,14,22,0.86) 100%)")
                        property("border", if (eigeneZuweisung) "2px solid #ff3b30" else "1px solid rgba(255,255,255,0.13)")
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Column)
                        gap(10.px)
                        property("box-shadow", "0 16px 30px rgba(0,0,0,0.24)")
                        cursor(if (eigeneZuweisung) "pointer" else "default")
                    }
                    if (eigeneZuweisung) onClick { starteWaAuftrag(lkw) }
                }) {
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            justifyContent(JustifyContent.SpaceBetween)
                            alignItems(AlignItems.Center)
                            gap(8.px)
                            flexWrap(FlexWrap.Wrap)
                        }
                    }) {
                        Span({ style { color(rgba(255, 255, 255, 0.82)); fontSize(13.px); fontWeight("600") } }) {
                            Text("Warenausgang")
                        }
                        Span({ style { color(rgba(255, 255, 255, 0.78)); fontSize(12.px); textAlign("right") } }) {
                            Text("Prio ${if (lkw.ablaufPrio > 0) lkw.ablaufPrio else lkw.prio.ifBlank { "-" }}")
                        }
                    }

                    MobileWaInfoRow("Fahrer", mobileWaFahrerLabel(lkw))
                    val sammelGroup = waLkwAll.mobileWaSammelGroup(lkw)
                    val waStandort = resolveWaStandort(lkw)
                    MobileWaInfoRow("Lieferscheinnummer", sammelGroup.mobileWaCompactLieferscheinnummer(lkw))
                    MobileWaInfoRow("PIN", yardPinCode(lkw))
                    MobileWaInfoRow("LKW", lkw.lkwkennzeichen.ifBlank { "-" })
                    MobileWaInfoRow("Auflieger", lkw.aufliegerkennzeichen.ifBlank { "-" })
                    MobileWaInfoRow("WA Platz", mobileWaStandortAnzeige(lkw, waStandort))
                    MobileWaInfoRow("Tor", mobileWaTorAnzeige(lkw, waStandort))
                    MobileWaInfoRow("Paletten offen", mobileWaOffenePalettenAnzeige(lkw, waStandort))
                    MobileWaInfoRow("Vorgeladen", mobileWaVorgeladenPalettenAnzeige(lkw))
                    MobileWaInfoRow("Status", mobileWaStatusText(lkw.zustand))
                }
            }
        }
    }
}

@Composable
private fun MobileWaArbeitsbereich(
    auftrag: All,
    content: @Composable () -> Unit
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(16.px)
            minHeight(100.percent)
            height(100.percent)
            width(100.percent)
            flex(1)
        }
    }) {
        MobileWaProcessHeader(auftrag)
        content()
    }
}

@Composable
private fun MobileWaPalettenscheinWarteScreen(
    fertig: Boolean,
    fehler: Boolean,
    gesamt: Int,
    verbleibend: Int,
    dokumentProgress: Int,
    statusText: String,
    mehrteiligerAbschluss: Boolean,
    onOk: () -> Unit
) {
    val total = gesamt.coerceAtLeast(1)
    val done = (total - verbleibend).coerceIn(0, total)
    val current = if (fertig) total else (done + 1).coerceIn(1, total)
    val currentProgress = dokumentProgress.coerceIn(0, 100)
    val progress = if (fertig) 100 else (((done * 100) + currentProgress) / total).coerceIn(0, 100)
    Div({
        style {
            flex(1)
            minHeight(220.px)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
        }
    }) {
        Div({
            style {
                width(100.percent)
                maxWidth(420.px)
                padding(18.px)
                borderRadius(8.px)
                backgroundColor(rgba(255, 255, 255, 0.06))
                property("border", "1px solid rgba(255,255,255,0.14)")
                textAlign("center")
                color(DashboardTheme.TEXT_LIGHT)
                fontSize(16.px)
                fontWeight("800")
                lineHeight("1.35")
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(14.px)
                alignItems(AlignItems.Center)
            }
        }) {
            Text(
                when {
                    fertig -> statusText.ifBlank { "Dokumente wurden erzeugt." }
                    fehler -> "Dokumente konnten nicht erzeugt werden. Bitte am Leitstand prüfen."
                    else -> "${statusText.ifBlank { "Dokumente werden erstellt" }} $current/$total"
                }
            )
            Div({
                style {
                    width(100.percent)
                    height(10.px)
                    borderRadius(999.px)
                    backgroundColor(rgba(255, 255, 255, 0.08))
                    property("overflow", "hidden")
                    property("border", "1px solid rgba(255,255,255,0.10)")
                }
            }) {
                Div({
                    style {
                        width(progress.percent)
                        height(100.percent)
                        backgroundColor(DashboardTheme.ACCENT)
                        property("transition", "width 220ms ease")
                    }
                })
            }
            Span({ style { color(DashboardTheme.TEXT_MUTED); fontSize(13.px); fontWeight("700") } }) {
                Text("$done/$total fertig")
            }
            if (fertig && !fehler) {
                Span({
                    style {
                        color(DashboardTheme.TEXT_LIGHT)
                        fontSize(15.px)
                        fontWeight("800")
                        lineHeight("1.45")
                    }
                }) {
                    Text(
                        if (mehrteiligerAbschluss) {
                            "Die Verladung ist an diesem Standort beendet. Die Dokumente wurden erzeugt."
                        } else {
                            "Die Verladung ist beendet. Die Dokumente wurden erzeugt."
                        }
                    )
                }
            }
            LumaticaButton(
                label = "Bestätigen",
                onClick = onOk,
                variant = LumaticaButtonVariant.Action,
                enabled = fertig && !fehler,
                heightPx = 42
            )
        }
    }
}

@Composable
private fun MobileWaNaechsterStandortScreen(
    auftrag: All,
    onWeiter: () -> Unit
) {
    Div({
        style {
            flex(1)
            minHeight(220.px)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
        }
    }) {
        Div({
            style {
                width(100.percent)
                maxWidth(420.px)
                padding(18.px)
                borderRadius(8.px)
                backgroundColor(rgba(255, 255, 255, 0.06))
                property("border", "1px solid rgba(255,255,255,0.14)")
                color(DashboardTheme.TEXT_LIGHT)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(14.px)
            }
        }) {
            Span({
                style {
                    fontSize(17.px)
                    fontWeight("900")
                    lineHeight("1.35")
                    textAlign("center")
                }
            }) {
                Text("Dieser Standort ist beendet. Es gibt noch einen weiteren WA-Standort.")
            }
            MobileWaInfoRow("Lieferscheinnummer", auftrag.lieferscheinnummer.ifBlank { "-" })
            MobileWaInfoRow("WA Platz", mobileWaStandortAnzeige(auftrag, null).ifBlank { "-" })
            MobileWaInfoRow("Tor", mobileWaTorAnzeige(auftrag, null))
            MobileWaInfoRow("Paletten offen", mobileWaOffenePalettenAnzeige(auftrag, null).ifBlank { "-" })
            LumaticaButton(
                label = "Weiter",
                onClick = onWeiter,
                variant = LumaticaButtonVariant.Action,
                heightPx = 42
            )
        }
    }
}

@Composable
private fun MobileWaPinBestaetigungScreen(
    auftrag: All,
    @Suppress("UNUSED_PARAMETER")
    onZurueck: () -> Unit,
    onPinBestaetigt: (All) -> Unit
) {
    var pinEingabe by remember(auftrag.id, auftrag.lfdNr) { mutableStateOf("") }
    var fehler by remember(auftrag.id, auftrag.lfdNr) { mutableStateOf("") }
    val erwartetePin = yardPinCode(auftrag)

    Div({
        style {
            flex(1)
            minHeight(0.px)
            height(100.percent)
            width(100.percent)
            position(Position.Relative)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
        }
    }) {
        Div({
            style {
                position(Position.Absolute)
                top(50.percent)
                left(50.percent)
                property("transform", "translate(-50%, -50%)")
                width(100.percent)
                maxWidth(360.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                gap(10.px)
                boxSizing("border-box")
            }
        }) {
            Input(InputType.Text) {
                value(pinEingabe)
                onInput {
                    pinEingabe = it.value.trim()
                    fehler = ""
                }
                attr("placeholder", "PIN eingeben")
                style {
                    height(58.px)
                    width(100.percent)
                    padding(0.px, 14.px)
                    borderRadius(8.px)
                    border(2.px, LineStyle.Solid, rgba(255, 255, 255, 0.34))
                    backgroundColor(rgba(0, 0, 0, 0.14))
                    color(Color.white)
                    fontSize(24.px)
                    fontWeight("900")
                    textAlign("center")
                    boxSizing("border-box")
                }
            }
            if (fehler.isNotBlank()) {
                Span({ style { color(Color("#ff6b6b")); fontSize(13.px); fontWeight("700"); textAlign("center") } }) {
                    Text(fehler)
                }
            }
        }
        Div({
            style {
                position(Position.Absolute)
                left(50.percent)
                bottom(0.px)
                property("transform", "translateX(-50%)")
                width(100.percent)
                maxWidth(360.px)
                boxSizing("border-box")
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.Center)
                alignItems(AlignItems.Center)
            }
        }) {
            LumaticaButton(
                label = "PIN bestätigen",
                onClick = {
                    if (pinEingabe == erwartetePin) {
                        onPinBestaetigt(auftrag)
                    } else {
                        fehler = "PIN stimmt nicht."
                    }
                },
                variant = LumaticaButtonVariant.Action,
                heightPx = 42
            )
        }
    }
}

@Composable
private fun MobileWaWarteScreen() {
    Div({
        style {
            flex(1)
            minHeight(220.px)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
        }
    }) {
        Div({
            style {
                width(100.percent)
                maxWidth(420.px)
                padding(18.px)
                borderRadius(8.px)
                backgroundColor(rgba(255, 255, 255, 0.06))
                property("border", "1px solid rgba(255,255,255,0.14)")
                textAlign("center")
                color(DashboardTheme.TEXT_LIGHT)
                fontSize(16.px)
                fontWeight("800")
                lineHeight("1.35")
            }
        }) {
            Text("Bitte warte bis der Fahrer das Ansetzen bestätigt hat.")
        }
    }
}

@Composable
private fun MobileWaProcessHeader(auftrag: All) {
    H3({
        style {
            margin(0.px)
            color(DashboardTheme.TEXT_LIGHT)
            fontSize(20.px)
            fontWeight("800")
            textAlign("center")
        }
    }) {
        Text("Warenausgang")
    }

    Div({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.SpaceBetween)
            gap(12.px)
            flexWrap(FlexWrap.Wrap)
        }
    }) {
        MobileWaProcessMetric(
            icon = "images/order.svg",
            value = auftrag.lieferscheinnummer.ifBlank { "-" }
        )
        MobileWaProcessMetric(
            icon = "images/toruebersicht.svg",
            value = auftrag.tor?.toString() ?: "-"
        )
        MobileWaProcessMetric(
            icon = "images/paletten.svg",
            value = auftrag.palettenanzahl.takeIf { it > 0 }?.toString() ?: "-"
        )
    }
}

@Composable
private fun MobileWaProcessMetric(icon: String, value: String) {
    Div({
        style {
            flex(1)
            minWidth(86.px)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            gap(8.px)
            minHeight(34.px)
        }
    }) {
        Img(src = icon) {
            style {
                width(24.px)
                height(24.px)
                property("filter", "brightness(0) invert(1)")
                flexShrink(0)
            }
        }
        Span({
            style {
                color(DashboardTheme.TEXT_LIGHT)
                fontSize(17.px)
                fontWeight("900")
                lineHeight("1")
                overflow("hidden")
                property("text-overflow", "ellipsis")
                property("white-space", "nowrap")
            }
        }) {
            Text(value)
        }
    }
}

@Composable
private fun MobileWaHeader(offen: Int, inBearbeitung: Int) {
    Div({
        style {
            padding(18.px)
            borderRadius(8.px)
            background("linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%), ${DashboardTheme.PREMIUM_SURFACE_BG}")
            property("border", "1px solid rgba(255,255,255,0.10)")
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            gap(12.px)
            textAlign("center")
        }
    }) {
        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                gap(10.px)
            }
        }) {
            Img(src = "images/wa.svg") {
                style {
                    width(34.px)
                    height(34.px)
                    property("filter", "brightness(1.8)")
                }
            }
            H3({ style { margin(0.px); color(DashboardTheme.TEXT_LIGHT); fontSize(20.px) } }) {
                Text("Warenausgang")
            }
        }
        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                gap(18.px)
                flexWrap(FlexWrap.Wrap)
            }
        }) {
            Span({ style { color(DashboardTheme.TEXT_LIGHT); fontSize(18.px); fontWeight("800") } }) {
                Text("$offen offen")
            }
            Span({ style { color(DashboardTheme.TEXT_MUTED); fontSize(18.px); fontWeight("800") } }) {
                Text("$inBearbeitung in Bearbeitung")
            }
        }
    }
}

@Composable
private fun MobileWaInfoRow(label: String, value: String) {
    if (value.isBlank()) return
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(3.px)
        }
    }) {
        Span({
            style {
                color(rgba(255, 255, 255, 0.48))
                fontSize(11.px)
                fontWeight("700")
                property("letter-spacing", "0.08em")
                property("text-transform", "uppercase")
            }
        }) { Text(label) }
        Span({
            style {
                color(DashboardTheme.TEXT_LIGHT)
                fontSize(14.px)
                lineHeight("1.35")
                property("word-break", "break-word")
            }
        }) { Text(value) }
    }
}

private fun mobileWaFahrerLabel(auftrag: All): String =
    auftrag.fahrername.ifBlank {
        auftrag.name.ifBlank {
            auftrag.lkwkennzeichen.ifBlank { "Unbekannter Fahrer" }
        }
    }

private fun mobileWaStandortAnzeige(lkw: All, waStandort: All?): String =
    waStandort?.platzcode.orEmpty()
        .ifBlank { waStandort?.platz.orEmpty() }
        .ifBlank { waStandort?.standort.orEmpty() }
        .ifBlank { lkw.platzcode }
        .ifBlank { lkw.platz }
        .ifBlank { lkw.standort }

private fun mobileWaTorAnzeige(lkw: All, waStandort: All?): String =
    lkw.tor?.toString().orEmpty()
        .ifBlank { waStandort?.tor?.toString().orEmpty() }
        .ifBlank { mobileWaStandortAnzeige(lkw, waStandort) }
        .ifBlank { "offen" }

private fun mobileWaOffenePalettenAnzeige(lkw: All, waStandort: All?): String =
    waStandort?.yardabschlussOffenPaletten?.takeIf { it > 0 }?.toString().orEmpty()
        .ifBlank { lkw.yardabschlussOffenPaletten.takeIf { it > 0 }?.toString().orEmpty() }
        .ifBlank { mobileWaOffenePalettenAusStandort(lkw, waStandort) }

private fun mobileWaOffenePalettenAusStandort(lkw: All, waStandort: All?): String {
    val soll = waStandort?.palettenanzahl?.takeIf { it > 0 }
        ?: waStandort?.palettenWerte.orEmpty().values.sumOf { it.toIntOrNull() ?: 0 }.takeIf { it > 0 }
        ?: return ""
    val ist = waStandort?.yardabschlussIstPaletten?.takeIf { it > 0 }
        ?: lkw.yardabschlussIstPaletten.takeIf { it > 0 }
        ?: lkw.mobilIstPaletten.takeIf { it > 0 }
        ?: 0
    return (soll - ist).coerceAtLeast(0).toString()
}

private fun mobileWaVorgeladenPalettenAnzeige(lkw: All): String =
    lkw.driverVorgeladenPaletten.takeIf { it > 0 }?.toString() ?: "0"

private fun mobileWaStatusText(zustand: Int): String =
    "$zustand - ${ZustandManager.textFor(zustand)}"

private fun All.mobileWaAbschlussKey(): String =
    listOf(
        lieferscheinnummer.ifBlank { id.ifBlank { lfdNr.toString() } },
        waStandortId
            .ifBlank { slotStandortId }
            .ifBlank { platzcode }
            .ifBlank { standort }
    ).filter { it.isNotBlank() }.joinToString("@")

private fun All.mobileWaSammelKey(): String {
    val slotMultiKey = mobileWaSlotMultiKey()
    if (slotMultiKey.isNotBlank()) return "SLOT_MULTI:$slotMultiKey:STANDORT:${mobileWaStandortSegmentKey()}"

    val stored = waSammelPin
        .ifBlank { waSammelId }
        .ifBlank { pin }
        .trim()
    return if (stored.isNotBlank()) "SAMMEL:$stored" else "SINGLE:${firmenId}:${lieferscheinnummer}:${id.ifBlank { lfdNr.toString() }}"
}

private fun All.mobileWaStandortSegmentKey(): String =
    waStandortId
        .ifBlank { slotStandortId }
        .ifBlank { platzcode }
        .ifBlank { platz }
        .ifBlank { standort }
        .ifBlank { tor?.toString().orEmpty() }
        .ifBlank { ablaufPrio.takeIf { it > 0 }?.toString().orEmpty() }
        .ifBlank { id.ifBlank { lfdNr.toString() } }

private fun All.mobileWaSlotMultiKey(): String {
    val refs = slotLadenTouren(this)
        .map { it.lieferscheinnummer.trim() }
        .filter { it.isNotBlank() }
        .distinct()
        .sorted()
    if (refs.size <= 1) return ""

    return listOf(
        firmenId,
        datum.ifBlank { verladedatum },
        uhrzeitVon.ifBlank { verladeuhrzeit }.ifBlank { uhrzeitAnmeldung },
        slotIndex,
        lkwkennzeichen,
        aufliegerkennzeichen,
        fahrername,
        refs.joinToString("+")
    ).map { it.trim() }.joinToString("|")
}

private fun List<All>.mobileWaSammelReps(): List<All> =
    groupBy { it.mobileWaSammelKey() }
        .values
        .map { group ->
            group.firstOrNull { it.zustand < ZustandManager.ABGESCHLOSSEN } ?: group.first()
        }

private fun List<All>.mobileWaSammelGroup(auftrag: All): List<All> {
    val key = auftrag.mobileWaSammelKey()
    return filter { it.mobileWaSammelKey() == key }
        .sortedWith(compareBy<All> { it.lieferscheinnummer }.thenBy { it.id })
}

private fun List<All>.mobileWaLieferscheinnummern(fallback: All): List<String> =
    ifEmpty { listOf(fallback) }
        .map { it.lieferscheinnummer.trim() }
        .filter { it.isNotBlank() }
        .distinct()
        .ifEmpty { listOf(fallback.lieferscheinnummer.trim()).filter { it.isNotBlank() } }

private fun List<All>.mobileWaCompactLieferscheinnummer(fallback: All): String {
    val nummern = mobileWaLieferscheinnummern(fallback)
    val first = nummern.firstOrNull().orEmpty().ifBlank { "-" }
    val rest = (nummern.size - 1).coerceAtLeast(0)
    return if (rest > 0) "$first + $rest" else first
}

private fun All.sameWaLkw(other: All): Boolean {
    if (lieferscheinnummer.isBlank() || other.lieferscheinnummer.isBlank()) return false
    if (lieferscheinnummer != other.lieferscheinnummer) return false
    return (id.isNotBlank() && id == other.id) ||
        (lfdNr > 0 && other.lfdNr > 0 && lfdNr == other.lfdNr)
}
